import { render, staticRenderFns } from "./SysCertificateForm.vue?vue&type=template&id=181bc64c&"
import script from "./SysCertificateForm.vue?vue&type=script&lang=js&"
export * from "./SysCertificateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181bc64c')) {
      api.createRecord('181bc64c', component.options)
    } else {
      api.reload('181bc64c', component.options)
    }
    module.hot.accept("./SysCertificateForm.vue?vue&type=template&id=181bc64c&", function () {
      api.rerender('181bc64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysCertificateForm.vue"
export default component.exports